import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import { changeStatusNewsStatus, deleteNews, getAllNews } from "../../../../api/news";
import { alertError, alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog';
import Table, { dateFormatter, substringFormatter } from "../../../components/tables/table";
import { buttonFormatterEditDisableDelete } from "../../../components/tables/buttonFormatterTable";
import { getNonEmpty } from '../../../../utils/helpers';

export default function NewsPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);
    const [refresh, setRefresh] = useState(false)
    const [news, setNews] = useState(null);
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState([])
    const [openConfirmDialog, setOpenConfirmDialog] = useState(null)

    useEffect(() => {
        getAllNews()
            .then((newsRes) => {
                const result = newsRes.data.map(news => ({
                    ...news,
                    title: getNonEmpty(news.title),
                    resume: getNonEmpty(news.resume),
                    id: news._id
                }));
                setData(result);
                setFilteredData(result);
                setRefresh(false);
            })
            .catch((error) => {
                alertError({
                    error: error,
                    customMessage: "Error fetching news.",
                });
            });
    }, [refresh]);

    const columns = [
        { dataField: "title", text: "News title", sort: true },
        { dataField: "site", text: "Site", sort: true },
        { dataField: "resume", text: "Resume", formatter: substringFormatter, sort: true },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true
        },
        {
            dataField: "id", text: "",
            formatter: (cell) => buttonFormatterEditDisableDelete(cell, "news", data, user?.role === "admin", setNews, setOpenConfirmDialog, history),
            headerStyle: { width: '200px' }
        },
    ];


    return (
        <Card>
            <CardHeader title="News list">
                <CardHeaderToolbar>
                    <button
                        type="button"
                        className="btn btn-primary text-white"
                        onClick={() => history.push("/edit-news")}
                    >
                        Add new
                    </button>
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                <Table data={filteredData} columns={columns} key={data.length} />

                <ConfirmDialog
                    title={`Are you sure you want to ${news?.active ? "deactivate" : "activate"} this news?`}
                    open={openConfirmDialog === 1}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        changeStatusNewsStatus(news.id, !news?.active)
                            .then((res) => {
                                alertSuccess({
                                    title: `${news?.active ? "Deactivate!" : "Activate!"
                                        }`,
                                    customMessage: `News ${news?.active ? "deactivate" : "activate"
                                        } successfully`,
                                });
                                setRefresh(true);
                            })
                            .catch((error) => {
                                alertError({
                                    error: error,
                                    customMessage: `Could not ${news?.active ? "deactivate" : "activate"
                                        } the news.`,
                                });
                            });
                    }}
                />

                <ConfirmDialog
                    title={'Are you sure you want to remove this news?'}
                    open={openConfirmDialog === 2}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        deleteNews(news.id)
                            .then((res) => {
                                alertSuccess({
                                    title: 'Deleted!',
                                    customMessage: 'News removed successfully.',
                                });
                                setRefresh(true);
                            })
                            .catch((error) => {
                                alertError({
                                    error: error,
                                    customMessage: 'Could not remove news.',
                                });
                            });
                    }}
                />
            </CardBody>
        </Card>
    );
}